// MIGRATED FROM: Solar API only
// MIGRATION DATE: 2024-08-25
// CHANGE TYPE: STANDARD - Solar API implementation
// BACKWARD COMPATIBLE: Yes - All existing treatment filter methods preserved

import { AxiosInstance } from 'axios'

import { buildApiEndpoint, createSolarApiClient } from '@/shared/libs/api-client'
import { TreatmentFilterResponse } from '@/features/treatment-category-filter/types/treatment-filter.type'

interface TreatmentFilterRequestBody {
  filters: {
    hospital: Record<string, unknown>
    serviceOffer: Record<string, unknown>
  }
  keyword?: string
}

export class TreatmentCategoryFilterService {
  constructor(private readonly apiClient: AxiosInstance) {}

  async getTreatmentCategoryFilter(
    body: TreatmentFilterRequestBody = {
      filters: {
        hospital: {},
        serviceOffer: {},
      },
      keyword: '',
    },
  ): Promise<TreatmentFilterResponse> {
    const config = buildApiEndpoint(
      {
        method: 'POST',
        url: '/display/search-view/service-offer-treatment-filter',
        data: body,
      },
      'solar',
    )

    const response = await this.apiClient.request<TreatmentFilterResponse>(config)
    return response.data
  }
}

export const clientTreatmentCategoryFilterService = new TreatmentCategoryFilterService(createSolarApiClient())
